// Static data for The Baker's Basket
// Replace placeholder phone numbers, addresses, and Zomato/Swiggy URLs with
// the real values whenever they are provided by the owners.

export const BRAND = {
    name: "The Baker's Basket",
    tagline: "Crafted with butter, time & love",
    foundedOn: "24th May 2023",
    founders: ["Aaditya Budhia", "Aditya Singh"],
    flagshipBranch: "Ambikapur",
    logo: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/mejera1j_bb%20straight.png",
};

export const COMPANY = {
    firmName: "Ans Bakery Company",
    gstin: "22ACBFA2596A1Z0",
    email: "ansbakerycompany@gmail.com",
    corporateOffice: "Office No. 101, Simrat Kunj, LIG-27, Sector 2, Opp. Galaxy Lounge Salon, Shankar Nagar, Raipur (C.G.) 492001",
    customerCare: {
        phone: "09977527710",
        email: "support@thebakersbasket.com",
    },
    franchiseEmail: "enquries@thebakersbasket.com",
    instagram: {
        handle: "thebakers_basket",
        url: "https://www.instagram.com/thebakers_basket/",
    },
};

export const FOUNDERS = [
    {
        id: "aaditya-budhia",
        name: "Aaditya Budhia",
        role: "Co-Founder & Managing Director",
        focus: "Backend Operations & Expansion",
        photo: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/3dfpweth_HDS06812.jpg",
        bio: "With over a decade in the food industry, Aaditya runs the engine room of The Baker's Basket — sourcing, systems, supply chain and the slow, careful work of opening new homes. Every branch you walk into has his fingerprints on it.",
        highlights: [
            "10+ years in the food industry",
            "Leads operations across all branches",
            "Heads expansion & new openings",
        ],
    },
    {
        id: "aditya-singh",
        name: "Aditya Singh",
        role: "Co-Founder & Managing Director",
        focus: "Customer Experience, Branding & Growth Strategy",
        photo: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/nw7667l2_WhatsApp%20Image%202026-05-16%20at%201.22.25%20PM.jpeg",
        bio: "Aditya combines hands-on international exposure from France with a strong foundation in entrepreneurship and business development. With a focus on customer experience, brand building and operational excellence, he brings a modern global perspective to the bakery while ensuring every detail reflects quality and authenticity.",
        highlights: [
            "Focused on customer experience, branding & growth strategy",
            "Leads front-of-house operations and business development",
            "Entrepreneurship & business management background",
        ],
    },
];

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/menu", label: "Menu" },
    { to: "/branches", label: "Branches" },
    { to: "/franchise", label: "Franchise", dropdown: true },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export const BRANCHES = [
    {
        id: "ambikapur",
        name: "Ambikapur",
        tagline: "Where it all began",
        address: "Sadar Road, Opp. Madhu Sweets, Ambikapur, Surguja, Chhattisgarh 497001",
        phone: "+91 78794-02674",
        whatsapp: "917879402674",
        hours: "10:00 AM – 11:00 PM (Daily)",
        opened: "24th May 2023",
        image: "https://customer-assets-lqy194kg.emergentagent.net/job_local-bakery-hub-3/artifacts/361c48e6173b24f9_WhatsApp%20Image%202026-10-20%20at%2012.42.26%20PM.jpeg",
        mapsUrl: "https://www.google.com/maps/place/The+Baker%E2%80%99s+Basket/@23.1216367,83.1785229,15z",
        mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18059.98001381024!2d83.17852288715821!3d23.121636700000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3989a31d8f6ef16d%3A0xd2da12d2d38c53e6!2sThe%20Baker%E2%80%99s%20Basket!5e1!3m2!1sen!2sin!4v1778846764914!5m2!1sen!2sin",
        zomatoUrl: "http://zoma.to/r/20723606",
        swiggyUrl: "https://www.swiggy.com/restaurants/the-bakers-basket-ambikapur",
    },
    {
        id: "surajpur",
        name: "Surajpur",
        tagline: "A neighbourhood favourite",
        address: "Nawapara Road, Opp. Punjab National Bank, Suresh Agrawal \"Babu\" RTO, Surajpur, Chhattisgarh 497229",
        phone: "+91 92449-97737",
        whatsapp: "919244997737",
        hours: "10:00 AM – 11:00 PM (Daily)",
        opened: "2nd March 2025",
        image: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/u5b392nn_WhatsApp%20Image%202026-05-15%20at%206.11.10%20PM.jpeg",
        mapsUrl: "https://www.google.com/maps/place/The+Baker's+Basket/@23.2121603,82.8683872,17z",
        mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4511.943534568949!2d82.86838718632492!3d23.212160255201013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398855f79b5cbd69%3A0x10f096845ef47057!2sThe%20Baker's%20Basket!5e1!3m2!1sen!2sin!4v1778847266339!5m2!1sen!2sin",
        zomatoUrl: null,
        swiggyUrl: null,
    },
    {
        id: "bishrampur",
        name: "Bishrampur",
        tagline: "Coffee, cakes & calm",
        address: "Beside Vijay Medicals, Opp. Surguja Electricals, Bishrampur, Chhattisgarh 497226",
        phone: "+91 92430-97737",
        whatsapp: "919243097737",
        hours: "10:00 AM – 11:00 PM (Daily)",
        opened: "4th September 2025",
        image: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/bhasgwsg_WhatsApp%20Image%202026-05-15%20at%206.13.47%20PM.jpeg",
        mapsUrl: "https://www.google.com/maps/place/The+Baker's+Basket/@23.1851228,82.9683627,17z",
        mapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4512.856122836017!2d82.96836267601131!3d23.185122810241307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3989abd832f1a0d5%3A0x465314091dacf107!2sThe%20Baker's%20Basket!5e1!3m2!1sen!2sin!4v1778847394594!5m2!1sen!2sin",
        zomatoUrl: null,
        swiggyUrl: null,
    },
];

export const MEDIA = {
    heroTexture: "https://static.prod-images.emergentagent.com/jobs/acb5c720-cd82-45e7-b818-82e6ee8fc663/images/ddf048fa88c919e14c4b80d9616d2c850f5fefdff84f5412ce19c145e02d81b7.png",
    deliveryApps: "https://static.prod-images.emergentagent.com/jobs/acb5c720-cd82-45e7-b818-82e6ee8fc663/images/9ba4edb007d88873df796acae3780594b0eea0d5b4af6d105ce439d49a6cfc58.png",
    foundersPortrait: "https://static.prod-images.emergentagent.com/jobs/acb5c720-cd82-45e7-b818-82e6ee8fc663/images/e17a8fa7dfc5bd6c3eee5e133acb135eb3c84bec58ae0beffaded23750e5cef5.png",
    breadDisplay: "https://images.unsplash.com/photo-1568254183919-78a4f43a2877?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxhcnRpc2FuYWwlMjBicmVhZCUyMHBhc3RyeSUyMGJha2VyeXxlbnwwfHx8fDE3Nzg4NDUzMjJ8MA&ixlib=rb-4.1.0&q=85",
    pastries: "https://images.unsplash.com/photo-1483695028939-5bb13f8648b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhcnRpc2FuYWwlMjBicmVhZCUyMHBhc3RyeSUyMGJha2VyeXxlbnwwfHx8fDE3Nzg4NDUzMjJ8MA&ixlib=rb-4.1.0&q=85",
    cafeOne: "https://images.unsplash.com/photo-1712730642507-d4ad0904e997?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxjb3p5JTIwd2FybSUyMGNhZmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg4NDUzMjJ8MA&ixlib=rb-4.1.0&q=85",
    belgianCake: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/k0zq0wnw_BELGIAN%20CAKE%20NEW%20DESIGN.PNG",
    attaChocoAlmond: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/x6depo89_ATTA%20CHOCO%20ALMOND%20DRY%20CAKE.PNG",
    aloopatties: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/lcgenc0b_Aloo%20patties.png",
    biscoffCheesecake: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/qbswm6gt_Biscoff%20cheesecake%20.png",
    blueberryCheesecake: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/kur5s9mu_Blueberry%20cheesecake%20.png",
    sugarKhari: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/gmejifv6_Sugar%20khari%20.png",
    whiteBread: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/g08171b0_White%20bread.png",
    belgianDarkShake: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/k8746yea_Bdc%20shake.png",
    weddingCake: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/cmo723e4_WhatsApp%20Image%202026-05-16%20at%204.38.21%20PM.jpeg",
};

// Per-category hero image (used as small banner on the Menu page).
// Categories without a key here render without a banner image.
export const CATEGORY_IMAGES = {
    "Cakes": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/k0zq0wnw_BELGIAN%20CAKE%20NEW%20DESIGN.PNG",
    "Cheese Cake Slice": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/qbswm6gt_Biscoff%20cheesecake%20.png",
    "Healthy Dry Cakes": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/x6depo89_ATTA%20CHOCO%20ALMOND%20DRY%20CAKE.PNG",
    "Khari": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/gmejifv6_Sugar%20khari%20.png",
    "Handcrafted Breads": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/g08171b0_White%20bread.png",
    "Café — Quick Hot Bites": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/lcgenc0b_Aloo%20patties.png",
    "Café — Thick Shakes (250ml)": "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/k8746yea_Bdc%20shake.png",
    "Custom Cakes (Premium)": {
        src: "https://customer-assets.emergentagent.com/job_local-bakery-hub-3/artifacts/cmo723e4_WhatsApp%20Image%202026-05-16%20at%204.38.21%20PM.jpeg",
        fit: "contain",
        bg: "#1a0f0d",
    },
};

// Real menu — sourced from The Baker's Basket digital menu (Jan 2026)
export const MENU = {
    "Cakes": [
        { name: "Classic Pineapple Cake", price: "₹350" },
        { name: "Black Forest Cake", price: "₹400" },
        { name: "Vintage Butterscotch Cake", price: "₹450" },
        { name: "Vancho Cake", price: "₹450" },
        { name: "Mix Fruits Cake", price: "₹500" },
        { name: "Choco Chips Cake", price: "₹500" },
        { name: "Dutch Truffle Cake", price: "₹550" },
        { name: "Choco Candy Cake", price: "₹600" },
        { name: "Ferrero Rocher Cake", price: "₹650" },
        { name: "Belgian Chocolate Cake", price: "₹800" },
    ],
    "Pastries": [
        { name: "Pineapple Pastry", price: "₹70" },
        { name: "Butterscotch Pastry", price: "₹80" },
        { name: "Choco Chips Pastry", price: "₹100" },
        { name: "Vancho Pastry", price: "₹100" },
        { name: "Dutch Truffle Pastry", price: "₹120" },
        { name: "Belgian Chocolate Pastry", price: "₹150" },
    ],
    "Cheese Cake Slice": [
        { name: "Tiramisu", price: "₹120" },
        { name: "Blueberry", price: "₹130" },
        { name: "Lotus Biscoff", price: "₹140" },
        { name: "Nutella", price: "₹150" },
    ],
    "Desserts": [
        { name: "Lollipop", price: "₹50" },
        { name: "Cakesicle", price: "₹100" },
        { name: "Chocolava", price: "₹100" },
        { name: "Walnut Brownie", price: "₹120" },
        { name: "Chocolate Mousse Pudding", price: "₹120" },
        { name: "Coffee Mousse Pudding", price: "₹120" },
        { name: "Nutella Brownie", price: "₹150" },
        { name: "Brownie Pot", price: "₹150" },
    ],
    "Cupcakes": [
        { name: "French Vanilla", price: "₹70" },
        { name: "Nutella", price: "₹80" },
        { name: "Kit-Kat", price: "₹80" },
    ],
    "Muffins": [
        { name: "Chocolate Muffin", price: "₹60" },
        { name: "Vanilla Chocochips Muffin", price: "₹60" },
    ],
    "Donuts": [
        { name: "Milkybar Donut", price: "₹100" },
        { name: "Kit-Kat Donut", price: "₹100" },
        { name: "Nutella Donut", price: "₹120" },
    ],
    "Croissants": [
        { name: "Chocolate Croissant", price: "₹120" },
        { name: "Double Baked Almond Chocolate Croissant", price: "₹150" },
    ],
    "Dry Cakes": [
        { name: "Tutti Fruity (250g)", price: "₹170" },
        { name: "Honey Almond (250g)", price: "₹200" },
        { name: "Choco Chips (250g)", price: "₹200" },
    ],
    "Healthy Dry Cakes": [
        { name: "100% Atta Dry Fruit (250g)", price: "₹200" },
        { name: "100% Atta Choco Almond (250g)", price: "₹230" },
        { name: "Millet Chocochips (250g)", price: "₹200" },
        { name: "Gud Banana Walnut (250g)", price: "₹230" },
    ],
    "Handcrafted Breads": [
        { name: "White Bread (Pkt)", price: "₹50" },
        { name: "Milk Bread (Pkt)", price: "₹50" },
        { name: "Brown Bread (Pkt)", price: "₹60" },
        { name: "100% Atta Bread (Pkt)", price: "₹60" },
        { name: "Multigrain Bread (Pkt)", price: "₹70" },
        { name: "Sandwich Bread Half (Pkt)", price: "₹50" },
        { name: "Pav (9 Pcs Pkt)", price: "₹40" },
        { name: "Pizza Base (Pack of 2)", price: "₹30" },
        { name: "Burger Bun (Pack of 4)", price: "₹40" },
    ],
    "Premium Cookies": [
        { name: "Pista Cookies (200g)", price: "₹140" },
        { name: "Chocochips Cookies (200g)", price: "₹140" },
        { name: "Coconut Almond Cookies (200g)", price: "₹140" },
        { name: "Famous Karachi Cookies (200g)", price: "₹140" },
        { name: "Dry Fruit Cookies (200g)", price: "₹140" },
        { name: "Butter Namkeen Cookies (200g)", price: "₹120" },
        { name: "Jeera Cookies (200g)", price: "₹120" },
        { name: "Nankhatai Cookies (200g)", price: "₹120" },
        { name: "Gems Choco Cookies (200g)", price: "₹160" },
        { name: "Crunchy Choco Cookies (200g)", price: "₹160" },
    ],
    "Healthy Cookies": [
        { name: "100% Atta Cookies (200g)", price: "₹120" },
        { name: "Oatmeal Cookies (200g)", price: "₹160" },
        { name: "Dates Atta Cookies (200g)", price: "₹160" },
        { name: "Gud Atta Cookies (200g)", price: "₹160" },
        { name: "Sugar-Free Choco Chunks Cookies (200g)", price: "₹180" },
        { name: "Sugar-Free Dry Fruits Cookies (200g)", price: "₹180" },
    ],
    "Khari": [
        { name: "Plain Khari (200g)", price: "₹70" },
        { name: "Methi Khari (200g)", price: "₹70" },
        { name: "Jeera Khari (200g)", price: "₹70" },
        { name: "Sugar Rush Khari (200g)", price: "₹70" },
        { name: "100% Atta Khari (200g)", price: "₹80" },
        { name: "Masala Cheese Straw (200g)", price: "₹100" },
    ],
    "Rusk & Toasts": [
        { name: "Milk Toast Rusk (200g)", price: "₹50" },
        { name: "100% Atta Rusk (200g)", price: "₹60" },
        { name: "Tutti Fruity Rusk (200g)", price: "₹70" },
        { name: "Butter Garlic Toast (200g)", price: "₹120" },
    ],
    "Custom Cakes (Normal)": [
        { name: "Vanilla Cake", price: "₹650 / kg" },
        { name: "Pineapple Cake", price: "₹650 / kg" },
        { name: "Strawberry Cake", price: "₹650 / kg" },
        { name: "Black Forest Cake", price: "₹750 / kg" },
        { name: "White Forest Cake", price: "₹750 / kg" },
        { name: "Choco Vanilla Cake", price: "₹750 / kg" },
        { name: "Butterscotch Cake", price: "₹850 / kg" },
        { name: "Vancho Cake", price: "₹850 / kg" },
        { name: "Choco Vancho Cake", price: "₹850 / kg" },
        { name: "Red Velvet Cake", price: "₹950 / kg" },
        { name: "Blueberry Cake", price: "₹950 / kg" },
        { name: "Mix Fruit Cake", price: "₹950 / kg" },
        { name: "Mango Cake", price: "₹950 / kg" },
        { name: "Rainbow Cake", price: "₹950 / kg" },
        { name: "Creamy Oreo Cake", price: "₹950 / kg" },
        { name: "Kit-Kat Cake", price: "₹950 / kg" },
        { name: "Tiramisu / Coffee Cake", price: "₹950 / kg" },
    ],
    "Custom Cakes (Premium)": [
        { name: "Choco Butterscotch Cake", price: "₹950 / kg" },
        { name: "Choco Chips Cake", price: "₹950 / kg" },
        { name: "Dutch Truffle Cake", price: "₹1050 / kg" },
        { name: "Rasmalai Cake", price: "₹1050 / kg" },
        { name: "Meetha Paan Cake", price: "₹1050 / kg" },
        { name: "Gajar ka Halwa Cake", price: "₹1050 / kg" },
        { name: "Cassata Cake", price: "₹1050 / kg" },
        { name: "Choco Almond Cake", price: "₹1150 / kg" },
        { name: "Gulab Jamun Cake", price: "₹1150 / kg" },
        { name: "Kaju Katli Cake", price: "₹1150 / kg" },
        { name: "Lotus Biscoff Cake", price: "₹1150 / kg" },
        { name: "Chocolava Cake", price: "₹1150 / kg" },
        { name: "Nutella Cake", price: "₹1150 / kg" },
        { name: "Ferrero Rocher Cake", price: "₹1250 / kg" },
        { name: "Choco Pista Cake", price: "₹1250 / kg" },
        { name: "Choco Biscoff Cake", price: "₹1350 / kg" },
        { name: "Belgian Chocolate Cake", price: "₹1550 / kg" },
    ],
    "Café — Quick Hot Bites": [
        { name: "Veg Patties (pc)", price: "₹30" },
        { name: "Paneer Patties (pc)", price: "₹40" },
        { name: "Mozzarella Cheese Pizza (pc)", price: "₹100" },
        { name: "Cheese Corn Pan Pizza (pc)", price: "₹120" },
        { name: "Veg Pan Pizza (pc)", price: "₹120" },
    ],
    "Café — Hot Beverages": [
        { name: "Espresso", price: "₹50 / ₹80" },
        { name: "Americano", price: "₹80" },
        { name: "Café Latte", price: "₹100" },
        { name: "Cappuccino", price: "₹100" },
        { name: "Mocha", price: "₹120" },
        { name: "Rich Hot Chocolate", price: "₹120" },
    ],
    "Café — Thick Shakes (250ml)": [
        { name: "Classic Cold Coffee", price: "₹130" },
        { name: "Mocha Frappe", price: "₹150" },
        { name: "Creamy Oreo Shake", price: "₹150" },
        { name: "Nutella Brownie Blast", price: "₹150" },
        { name: "Kit-Kat Break Shake", price: "₹130" },
        { name: "Blueberry Shake", price: "₹100" },
        { name: "Strawberry Shake", price: "₹100" },
        { name: "Ferrero Delight", price: "₹150" },
        { name: "Belgian Dark Chocolate", price: "₹150" },
    ],
};

// Subtitle / blurb per category for the menu page
export const MENU_CATEGORY_NOTES = {
    "Cakes": "Whole cakes baked daily. Pick one off the shelf or pre-order ahead.",
    "Pastries": "Single-serve happiness. Layered, glazed, never boring.",
    "Cheese Cake Slice": "Baked, chilled and ridiculously creamy — by the slice.",
    "Desserts": "Brownies, mousses & little jars of joy.",
    "Cupcakes": "Personal-sized celebrations, one bite away.",
    "Muffins": "Tender crumb, big tops. Best with morning chai.",
    "Donuts": "Hand-glazed, never tired.",
    "Croissants": "72-hour fermented, hand-laminated, butter-forward.",
    "Dry Cakes": "Tea-time loaves that travel well.",
    "Healthy Dry Cakes": "Atta, millet, gud — the good stuff, baked the right way.",
    "Handcrafted Breads": "Breads we'd happily feed our own families.",
    "Premium Cookies": "Crisp, buttery, and dangerously moreish — sold by the box.",
    "Healthy Cookies": "Made with atta, dates, gud and a lot less sugar.",
    "Khari": "Crisp Parsi-style flaky bites — perfect with chai.",
    "Rusk & Toasts": "Crunchy, golden, dunk-worthy.",
    "Custom Cakes (Normal)": "Made-to-order. Please place orders 24 hours in advance.",
    "Custom Cakes (Premium)": "Speciality flavours for the big moments. Order 24–72 hrs ahead.",
    "Café — Quick Hot Bites": "Fresh out of the oven, ready in minutes.",
    "Café — Hot Beverages": "Single-origin beans, properly extracted.",
    "Café — Thick Shakes (250ml)": "Cold, thick, and unapologetically indulgent.",
};
